import React from 'react'
import styled from 'styled-components'
import { graphql } from 'react-apollo'
import PropTypes from 'prop-types'
import Category from './Category'
import { LoanProvider } from '../shared/LoanContext'
import { HelloSignProvider } from './contexts/HelloSignContext'
import Loader from '../common/Loader'
import Error from '../common/Error'
import DocumentsQuery from './queries/DocumentsQuery'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`
const Title = styled.h2``
const ProgressContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
`
const ProgressBar = styled.span`
  border: 1px #edebeb solid;
  height: 25px;
  width: 200px;
  margin-right: 10px;
`
const Progress = styled.div`
  width: ${props => props.percent}%;
  background: #339952;
  height: 100%;
`
const categories = {
  business_entity: 'Entity',
  business_affiliate: 'Affiliate',
  business_use_of_proceeds: 'Use of Proceeds',
  business_financial_and_underwriting: 'Financial & Underwriting',
  business_location: 'Location',
  business_franchise: 'Franchise',
  business_insurance: 'Insurance',
  business_sba_forms_and_loan: 'SBA Forms & Loan',
  business_bank_search: 'Bank Searches',
  business_funding: 'Funding Documents',
  business_uncategorized: 'Additional Documents'
}
class Pane extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      error: PropTypes.object,
      loading: PropTypes.bool,
      loan: PropTypes.shape({
        affiliates: PropTypes.arrayOf(PropTypes.object),
        businesses: PropTypes.arrayOf(PropTypes.object)
      })
    })
  }
  getGuarantors = () => {
    const { affiliates, businesses } = this.props.data.loan
    let guarantors = []
    for (const business of businesses) {
      guarantors = guarantors.concat(business.guarantors).concat(business.corporateGuarantors).concat(business.seniorStaff)
    }
    return guarantors.concat(affiliates)
  }
  renderCategories = () => {
    const {
      entityId,
      handedOff,
      resourceType,
      data,
      loanId,
      superUser,
      canComment,
      bankAdmin,
      customerService,
      idx,
      disableUnderwriter = false,
    } = this.props
    const { affiliates, businesses } = data.loan
    const guarantors = this.getGuarantors()
    const affiliateIds = affiliates.map(({ rid }) => rid)
    const commonProps = {
      affiliateIds,
      resourceType,
      loanId,
      handedOff,
      categories,
      resetClientStore: this.resetClientStore
    }

    if (resourceType === 'Business') {
      const entity = businesses.find(({ rid }) => rid === entityId)
      const { documents } = entity

      return Object.keys(categories).map((cat, i) => {
        const docs = documents.filter(doc => doc.category === cat)
        if (docs.length > 0) {
          return (
            <Category
              id={`category_${i}`}
              key={cat}
              entity={entity}
              entityId={entityId}
              title={categories[cat]}
              documents={docs}
              guarantors={guarantors}
              superUser={superUser}
              canComment={canComment}
              bankAdmin={bankAdmin}
              customerService={customerService}
              idx={idx}
              category={cat}
              {...commonProps}
            />
          )
        }
      })
    } else if (resourceType === 'Guarantor') {
      return guarantors.map((g, i) => {
        const { documents, name, rid } = g

        if (documents.length > 0) {
          const filteredDocs =
            documents.filter(({ type }) => !(type === 'Document::DriverLicensePhoto' && disableUnderwriter))

          return (
            <Category
              id={`category_${i}`}
              key={`${name}-${rid}`}
              entityId={rid}
              title={name}
              documents={filteredDocs}
              guarantors={guarantors}
              superUser={superUser}
              canComment={canComment}
              bankAdmin={bankAdmin}
              customerService={customerService}
              guarantor={g}
              entity={g}
              {...commonProps}
            />
          )
        }
      })
    } else if (resourceType === 'Archived') {
      const allBusinesses = businesses.filter(b => b.borrowerType !== 'affiliate')
      const entities = allBusinesses.concat(guarantors)
      return entities.map((e, i) => {
        const { archivedDocuments, name, rid } = e
        const title = e.__typename === 'Business' ? `${e.name} Business` : e.name
        return (
          <Category
            id={`category_${i}`}
            key={`${name}-${rid}`}
            entityId={rid}
            title={title}
            documents={archivedDocuments}
            guarantors={guarantors}
            entity={{}}
            disabled
            superUser={superUser}
            isArchived
            {...commonProps}
          />
        )
      })
    }
  }
  renderTitle = () => {
    const { resourceType, entityId, data } = this.props
    const { businesses } = data.loan
    if (resourceType === 'Archived') {
      return
    }
    const isBusiness = resourceType === 'Business'
    const { name } = isBusiness ? businesses.find(({ rid }) => rid === entityId) : businesses.find(({ borrowerType }) => borrowerType === 'oc')
    return <Title id="documents_section_title">{name} {resourceType} Documents</Title>
  }
  renderProgress = () => {
    const { percentage, resourceType } = this.props
    if (resourceType !== 'Archived') {
      return (
        <ProgressContainer id="documents_progress">
          <ProgressBar>
            <Progress percent={percentage} />
          </ProgressBar>
          <span>{percentage}% Uploaded</span>
        </ProgressContainer>
      )
    }
  }
  resetClientStore = () => {
    const { client } = this.props
    client.resetStore()
  }
  render() {
    const { data } = this.props
    const { loading, error, loan, helloSign } = data
    if (loading) {
      return <Loader number={4} />
    }
    if (error) {
      return <Error />
    }
    return (
      <LoanProvider value={loan}>
        <HelloSignProvider value={helloSign}>
          <Container>
            {this.renderTitle()}
            {this.renderProgress()}
            {this.renderCategories()}
          </Container>
        </HelloSignProvider>
      </LoanProvider>
    )
  }
}

export { Pane }

export default graphql(DocumentsQuery, {
  options: ({ loanId }) => ({
    variables: {
      rid: loanId
    }
  })
})(Pane)
